/* eslint-disable no-underscore-dangle */
import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  from,
  InMemoryCache,
} from "@apollo/client";
import fetch from "cross-fetch";
import { useConfig } from "./components/proposals/contexts/configContext";

import getErrorHandler from "./utils/graphqlErrorHandler";

/**
 * Use a federated graphql service uri provided as an environment variable or default to the
 * mock graphql api url -> localhost:8001. We will want this in a variable eventually too.
 */

export function useClient() {
  const { authHeaders, isThomasnet, mockGraphqlServer, origins } = useConfig();

  const federationLink = from([
    getErrorHandler("marketplace-frontend"),
    new HttpLink({
      uri: isThomasnet
        ? `${origins.thomasnetXApi}/api/graphql/`
        : origins.graphql,
      fetch,
      headers: { ...authHeaders },
      credentials: mockGraphqlServer ? "omit" : "include",
    }),
  ]);

  const thomasPublicLink = from([
    getErrorHandler("thomas-public-gql"),
    new HttpLink({
      uri: origins.thomasnetPublicGql,
      fetch,
      headers: { ...authHeaders },
      credentials: "omit",
    }),
  ]);

  const thomasAuthLink = from([
    getErrorHandler("thomas-auth-gql"),
    new HttpLink({
      uri: origins.thomasnetAuthGql,
      fetch,
      headers: { ...authHeaders },
      credentials: mockGraphqlServer ? "omit" : "include",
    }),
  ]);

  const thomasLink = ApolloLink.split(
    operation => {
      const ctx = operation.getContext();
      return ctx.clientName === "thomas" && ctx.thomasAuth;
    },
    thomasAuthLink,
    thomasPublicLink
  );

  return new ApolloClient({
    link: ApolloLink.split(
      operation => operation.getContext().clientName === "thomas",
      thomasLink,
      federationLink
    ),
    cache: new InMemoryCache({
      typePolicies: {
        MarketplaceForm: {
          keyFields: ["id", "versionId"],
        },
      },
    }),
  });
}

export function usePfsClient() {
  const { authHeaders, mockGraphqlServer, origins } = useConfig();

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: from([
      getErrorHandler("part-file-service"),
      new HttpLink({
        uri: `${origins.partFilesService}/graphql`,
        fetch,
        headers: { ...authHeaders },
        credentials: mockGraphqlServer ? "omit" : "include",
      }),
    ]),
  });
}
